// Google Ads conversion tracking.
//
// The gtag.js base tag lives in public/index.html; this module only fires
// events. Every call no-ops when gtag isn't present (ad blockers, local dev,
// network failure) so tracking can never break the scorecard flow.

const LEAD_FORM_CONVERSION = 'AW-18358627312/bSzcCN3_z9gcEPDXibJE';

// Fired once per completed submission, from Scorecard's submit handler —
// not on the results page, which is a private URL a visitor can reload or
// revisit and would double-count.
export function trackLeadConversion() {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', 'conversion', { send_to: LEAD_FORM_CONVERSION });
}
